import React from 'react';
import styled from 'styled-components/macro';
import { Field } from 'formik';
import { ReactComponent as CheckmarkIcon } from 'assets/icons/checkmark.svg';

const IconCheckbox = styled(CheckmarkIcon)`
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
  transform: translate(-50%, -50%);
`;

const CheckboxWrapper = styled.label`
  height: 1rem;
  display: flex !important;
  margin-bottom: 0 !important;
  position: relative;
  cursor: pointer;
  align-items: center;
`;

const CheckboxInput = styled.input`
  width: 1rem;
  height: 1rem;
  margin: 0;
  opacity: 0;
`;

const InputBox = styled.div<{ isChecked: boolean }>`
  background-color: ${({ isChecked }) =>
    isChecked ? 'rgb(31, 93, 234)' : 'transparent'};
  border: 1px solid
    ${({ isChecked }) => (isChecked ? 'rgb(31, 93, 234)' : 'black')};
  width: 1rem;
  height: 1rem;
  display: block;
  margin-bottom: 0 !important;
  cursor: pointer;
`;

interface Props {
  isChecked: boolean;
  fieldName: string;
  label: string;
}

const Checkbox = ({ isChecked, label, fieldName }: Props) => {
  return (
    <CheckboxWrapper>
      <InputBox isChecked={isChecked} />
      <IconCheckbox />
      <Field name={fieldName} type="checkbox" as={CheckboxInput} />
      {label}
    </CheckboxWrapper>
  );
};

export default Checkbox;
